/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputAdminPositionStockMovement
 */
export interface OutputAdminPositionStockMovement {
    /**
     * 
     * @type {string}
     * @memberof OutputAdminPositionStockMovement
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminPositionStockMovement
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminPositionStockMovement
     */
    createdBy?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminPositionStockMovement
     */
    createdByName?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminPositionStockMovement
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminPositionStockMovement
     */
    movementType?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminPositionStockMovement
     */
    quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminPositionStockMovement
     */
    stockItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminPositionStockMovement
     */
    stockItemName?: string;
}

/**
 * Check if a given object implements the OutputAdminPositionStockMovement interface.
 */
export function instanceOfOutputAdminPositionStockMovement(value: object): boolean {
    return true;
}

export function OutputAdminPositionStockMovementFromJSON(json: any): OutputAdminPositionStockMovement {
    return OutputAdminPositionStockMovementFromJSONTyped(json, false);
}

export function OutputAdminPositionStockMovementFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAdminPositionStockMovement {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'] == null ? undefined : json['comment'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdByName': json['createdByName'] == null ? undefined : json['createdByName'],
        'id': json['id'] == null ? undefined : json['id'],
        'movementType': json['movementType'] == null ? undefined : json['movementType'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'stockItemId': json['stockItemId'] == null ? undefined : json['stockItemId'],
        'stockItemName': json['stockItemName'] == null ? undefined : json['stockItemName'],
    };
}

export function OutputAdminPositionStockMovementToJSON(value?: OutputAdminPositionStockMovement | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'comment': value['comment'],
        'createdAt': value['createdAt'],
        'createdBy': value['createdBy'],
        'createdByName': value['createdByName'],
        'id': value['id'],
        'movementType': value['movementType'],
        'quantity': value['quantity'],
        'stockItemId': value['stockItemId'],
        'stockItemName': value['stockItemName'],
    };
}

